import { SiteConfig } from './classes/misc/SiteConfig/SiteConfig';

export const config = new SiteConfig();
